import React from 'react'

export function DetailList({items}) {
  return (
    <>
    <div className="modal fade" id="modal-detail">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Ver Detalles</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
                <div className="card bg-light  m-0">
                    <div className="card-body">
                    <table className="table table-bordered text-center mt-3">
                        <thead>
                        <tr className='text-uppercase'>
                            <td className="align-middle bg-gradient-dark ">
                            sku
                            </td>
                            <td className="align-middle bg-gradient-dark">
                            Producto
                            </td>
                            <td className="align-middle bg-gradient-dark">
                            Unidad
                            </td>
                            <td className="align-middle bg-gradient-dark">
                            Cantidad
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        {items.map((o, index) => {
                            return (
                            <tr key={index} value={o.productID}>
                                <td className="align-middle">{o.sku}</td>
                                <td className="align-middle">{o.productName}</td>
                                <td className="align-middle">{o.unitName}</td>
                                <td className="align-middle">{o.quantity}</td>
                                
                            </tr>
                            );
                        })}
                        </tbody>
                    </table>

                    </div>
                </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
                id="btn-close-modal-detail"
              >
                Close
              </button>
             
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
